export const blockIconsAudioandvideoLibraryBooksNew = (
	<span className='material-symbols-outlined'>library_books</span>
);
